<!-- eslint-disable vue/no-parsing-error -->
<template>
  <div class="news_wrap">
    <div class="pc_container">
      <!-- <div class="en_tit">{{ news.info.en }}</div>
      <div class="news_tit">{{ news.info.title }}</div> -->
      <div class="news_detail">
        <div class="news_left">
          <div class="news_tab">
            <div
              class="news_tab_item"
              v-for="(item, index) in news.list"
              :key="index"
              :class="activeIndex === index ? 'active' : ''"
              @click="changeIndex(index, item)"
            >
              <div class="news_tab_item_tit">{{ item.info.title }}</div>
            </div>
            <div class="more" @click="more(href)">&gt;&gt;更多</div>
          </div>
          <div class="textList">
            <div
              v-for="(item, index) in news.list"
              :key="index"
              v-if="activeIndex === index"
            >
              <div
                class="news_item"
                :class="activePicIndex === j ? 'active' : ''"
                v-for="(i, j) in item.list"
                :key="j"
                @mouseover="changePicIndex(j)"
              >
                <div class="num">{{ j < 10 ? "0" + (j + 1) : j + 1 }}</div>
                <div class="news_item_detail"  @click="handleToNewsDetails(i)">
                  <div class="news_item_tit">
                    <div class="t1">{{ i.title }}</div>
                    <div class="t2">{{ i.updated_at }}</div>
                  </div>
                  <div class="news_item_content ">{{ i.excerpt }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="picInfo">
          <div class="picInfo_item">
            <div>
              <div class="picInfo_item_img">
                <img :src="news.list[activeIndex].list[activePicIndex].cover" alt="" />
              </div>
              <div class="picInfo_item_tit">{{ news.list[activeIndex].list[activePicIndex].title }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    news: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      activeIndex: 0,
      activePicIndex: 0,
      href: "",
      slug: "",
    };
  },
  methods: {
    handleToNewsDetails(item) {
      this.$router.push({
        path: "/news/detail",
        query: {
          id: item.id,
          type: item.category.slug,
        },
      });
    },
    changeIndex(index, item) {
      this.href = item.info.href;
      this.slug = item.info.slug;
      this.activeIndex = index;
      this.activePicIndex = 0;
    },
    changePicIndex(index) {
      this.activePicIndex = index;
    },
    more(href) {
      this.$router.push(href);
    },
  },
  created() {
    this.slug = this.news.list[0].info.slug;
    this.href = this.news.list[0].info.href;
  },
};
</script>

<style lang="scss" scoped>
.text-one {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.news_wrap {
  width: 100%;
  padding-top: 30px;
  padding-bottom: 30px;
  text-align: center;
  background: #fcfcfc;

  .en_tit {
    font-family: SourceHanSansCN-Bold;
    font-size: 48px;
    color: #dcdcdc;
    text-transform: uppercase;
  }

  .news_tit {
    font-family: SourceHanSansCN-Bold;
    font-size: 36px;
    color: #000;
    margin-top: -15px;
    position: relative;

    @media screen and (max-width: 768px) {
      font-size: 1.2rem;
    }

    &::after {
      content: "";
      display: block;
      background: #000;
      margin: 0 auto;
      width: 60px;
      height: 5px;
      background: #006de8;
      margin-top: 13px;
    }
  }

  .news_detail {
    width: 100%;
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    height: 505px;
    .news_left {
      width: calc(100% - 620px);
      .news_tab {
        height: 74px;
        background: #e9e9e9;
        width: 100%;
        .news_tab_item {
          padding: 0 45px;
          cursor: pointer;
          color: #666;
          line-height: 74px;
          font-size: 18px;
          float: left;
        }

        .news_tab_item.active {
          padding: 0 45px;
          color: #fff;
          background: #2a59ab;
        }

        .more {
          margin-right: 29px;
          line-height: 74px;
          color: #2a59ab;
          font-size: 18px;
          float: right;
          cursor: pointer;
        }
      }

      .textList {
        display: flex;
        flex-direction: column;
        text-align: left;
        width: 100%;

        .news_item {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          margin-top: 41px;
          margin-bottom: 10px;
          overflow: hidden;
          cursor: pointer;
         &.active {
            background-color: #f6f6f6;
            .num {
              background: #2a59ab;
            }
          }
          .num {
            width: 56px;
            height: 56px;
            background: #dcdcdc;
            color: #fff;
            margin-right: 14px;
            font-size: 30px;
            text-align: center;
            line-height: 56px;
            flex-shrink: 0;
          }

          .num.activePic {
            background: #2a59ab;
          }

          .news_item_detail {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: calc(100% - 76px);

            .news_item_tit {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              width: 100%;

              .t1 {
                font-size: 16px;
                color: #333;
                width: calc(100% - 150px);
                height: 28px;
                overflow: hidden;
              }

              .t2 {
                font-size: 16px;
                color: #333;
                width: 130px;
              }
            }

            .news_item_content {
              font-size: 14px;
              color: #999;
              max-width: 100%;
              height: 40px;
              line-height: 20px;
              overflow: hidden;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
            }
          }
        }
      }
    }

    .picInfo {
      width: 600px;
      height: 505px;
      box-sizing: border-box;
      overflow: hidden;
      position: relative;

      .picInfo_item_img {
        img {
          width: 100%;
          height: 505px;
        }
      }

      .picInfo_item_tit {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 69px;
        line-height: 69px;
        color: #fff;
        font-size: 16px;
        text-align: left;
        background: #2a59ab;
        overflow: hidden;
        padding: 0 25px;
      }
    }
  }
}
</style>